import React from 'react';
import { Link } from 'react-router-dom';
import SideBar from '../components/SideBar';

const Error = () => {
  return (
    <main>
      <div className="SideBar">
        <SideBar />
      </div>
      <div className="FilterContainer" id="Error">
        <section className="error-page section">
          <div className="error-container">
            <h1>dead end - oops!</h1>
            <Link to="/" className="btn btn-primary">back home</Link>
          </div>
        </section>
      </div>
    </main>
  );
};

export default Error;
